import React, { FunctionComponent, ReactElement } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';

export interface SecondaryAction {
  disabled?: boolean;
  alignLeft?: boolean;

  tooltip?: string;
  icon: ReactElement<SvgIconProps>;

  onClick: (templateId: number) => void;
  key: string;
}

interface Props {
  template: any;
  action: SecondaryAction;
}

const TemplateAction: FunctionComponent<Props> = ({ action, template }) => {
  const actionButton = (
    <IconButton onClick={() => action.onClick(template.id)} disabled={action.disabled === true}>
      {action.icon}
    </IconButton>
  );

  if (action.tooltip == null) {
    return actionButton;
  }

  return (
    <Tooltip
      disableInteractive
      disableFocusListener
      title={action.tooltip}
      placement={action.alignLeft ? 'right-end' : 'bottom'}
    >
      <span>{actionButton}</span>
    </Tooltip>
  );
};

export default TemplateAction;
